/* =============================================================================
 * M.M.LaFleur — place the True Fit widget in the buy column.
 *
 * True Fit's guide asks for its div to sit "just above or below your size
 * selector". That is inside sections/mm_product.liquid, which is ~70KB with no
 * patch operation on the Admin API — every edit retransmits the whole file.
 *
 * So the div is RENDERED where Liquid can cheaply reach it (the first gallery
 * frame, in mm_product_media.liquid, which is the same seam the sale label and
 * the PDP stylesheet already use) and MOVED here, once, to sit above the SIZE
 * block. Same pattern as mm-pdp-sale-label.js, and for the same reason.
 *
 * WHY THE DIV IS RENDERED IN LIQUID RATHER THAN BUILT HERE
 * -------------------------------------------------------
 * It carries three values only Liquid knows: the product id, the locale pair,
 * and the logged-in customer id. Building the element in JavaScript would mean
 * publishing all three into a global for this file to read — more moving parts,
 * and the id would be a second copy of something the page already states.
 *
 * WHY calculate() IS CALLED AFTER MOVING
 * --------------------------------------
 * True Fit scans for .tfc-fitrec-product when its library loads. If that scan
 * happens before the move, or the colourway swap re-renders the buy column
 * underneath it, the widget is left pointing at an element no longer in the
 * tree and silently renders nothing. tfcapi('calculate') asks it to look again.
 * The call is queued by the stub in the head snippet, so it is safe to make
 * before the library itself has finished loading.
 *
 * THE 24-48 HOUR CAVEAT: True Fit normalises the catalogue after install and
 * the widget does not appear until that finishes. An empty div on the PDP in
 * the meantime is expected, not a placement bug.
 * ========================================================================== */

(function () {
  "use strict";

  if (window.__mmTrueFitBound) return;
  window.__mmTrueFitBound = true;

  function recalc() {
    if (typeof window.tfcapi === "function") window.tfcapi("calculate");
  }

  function place() {
    var widget = document.querySelector(".tfc-fitrec-product");
    if (!widget) return;

    var sizes = document.querySelector(".mm-pdp-sizes");
    if (!sizes) return;

    /* The size grid's own block, so the widget lands between the colourway row
       and SIZE rather than between the SIZE heading and its chips. */
    var block = sizes.closest(".mm-pdp-block") || sizes;
    if (!block.parentNode) return;

    /* Already in position — and this check is what stops the observer below
       from reacting to its own move. */
    if (widget.nextElementSibling === block) return;

    block.parentNode.insertBefore(widget, block);
    recalc();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", place);
  } else {
    place();
  }

  /* Barba replaces <main> without firing an event this can listen for, and a
     colourway swap re-renders the buy column in place. Both land here. */
  if (window.MutationObserver) {
    var pending = null;
    new MutationObserver(function () {
      if (pending) return;
      pending = window.requestAnimationFrame(function () {
        pending = null;
        place();
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
}());
